import { configureStore } from '@reduxjs/toolkit';
// Import auth reducer
import authReducer from './store/slices/authSlice';
// Import client reducer
import clientReducer from './modules/clients/actions/clientSlice';
// Import download tracker reducer
import downloadsTrackerReducer from './store/slices/downloadsTrackerSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    clients: clientReducer,
    downloadsTracker: downloadsTrackerReducer,
  },
});



export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;